import { mergeOverrides } from '@lyearn/ui';

import DialogBody from '../Primitives/DialogBody';
import { DialogBodyProps } from '../Primitives/DialogBody/types';
import DialogRoot from '../Primitives/DialogRoot';
import { DefaultModalProps } from './types';

const styles: DialogBodyProps['styles'] = {
  header: { className: 'px-24 pt-28 pb-16 border-b border-bg-primary' },
  footer: { className: 'p-24 border-t border-bg-primary', variant: 'fullWidth' },
};

const DefaultModal = (props: DefaultModalProps) => {
  const { open, onClose, contentClassName = 'pt-16 pb-32', styles: stylesProp, ...rest } = props;

  const _styles = mergeOverrides(styles, stylesProp);

  return (
    <DialogRoot maxHeight="80%" open={open} width={520} onClose={onClose}>
      <DialogBody
        {...rest}
        contentClassName={contentClassName}
        styles={_styles}
        onClose={onClose}
      />
    </DialogRoot>
  );
};

export default DefaultModal;
